export default __webpack_public_path__ + "static/media/student projetcs.9c6159da.jpg";